import { ALERT_KIND_LABELS } from '@ldembalagens/types';
import { useQuery } from '@tanstack/react-query';
import { Bell } from 'lucide-react';
import { Link } from 'react-router-dom';
import { Badge } from '@/components/ui/badge';
import { Button } from '@/components/ui/button';
import { Popover, PopoverContent, PopoverTrigger } from '@/components/ui/popover';
import { documentsApi, documentsKeys } from '@/features/documents/documents-api';

/** Sino de alertas no cabeçalho: vencimentos, atrasos e pendências conforme as permissões do usuário. */
export function AlertsBell() {
  const alerts = useQuery({
    queryKey: documentsKeys.alerts,
    queryFn: documentsApi.alerts,
    refetchInterval: 5 * 60 * 1000,
    staleTime: 60 * 1000,
  });
  const total = alerts.data?.total ?? 0;
  const critical = alerts.data?.critical ?? 0;
  return (
    <Popover>
      <PopoverTrigger asChild>
        <Button variant="ghost" size="icon" className="relative" aria-label={`Alertas (${total})`}>
          <Bell />
          {total > 0 ? (
            <span
              className={`absolute top-0.5 right-0.5 flex h-4 min-w-4 items-center justify-center rounded-full px-1 text-[10px] font-semibold text-white ring-2 ring-card ${critical > 0 ? 'bg-destructive' : 'bg-warning'}`}
            >
              {total > 99 ? '99+' : total}
            </span>
          ) : null}
        </Button>
      </PopoverTrigger>
      <PopoverContent align="end" className="w-80 p-0">
        <div className="flex items-center justify-between border-b px-3 py-2">
          <p className="text-sm font-semibold">Alertas</p>
          <Button asChild variant="link" size="sm" className="h-auto p-0">
            <Link to="/alertas">Ver todos</Link>
          </Button>
        </div>
        <div className="max-h-80 overflow-y-auto">
          {total === 0 ? (
            <p className="px-3 py-6 text-center text-sm text-muted-foreground">
              Nenhum alerta no momento.
            </p>
          ) : (
            <ul className="divide-y">
              {(alerts.data?.items ?? []).slice(0, 8).map((a, i) => (
                <li key={`${a.kind}-${a.entityId}-${i}`}>
                  <Link to={a.link} className="block px-3 py-2 hover:bg-muted/60">
                    <div className="flex items-center justify-between gap-2">
                      <Badge
                        variant={
                          a.severity === 'critical'
                            ? 'destructive'
                            : a.severity === 'warning'
                              ? 'warning'
                              : 'muted'
                        }
                      >
                        {ALERT_KIND_LABELS[a.kind]}
                      </Badge>
                    </div>
                    <p className="mt-1 truncate text-sm font-medium">{a.title}</p>
                    <p className="truncate text-xs text-muted-foreground">{a.description}</p>
                  </Link>
                </li>
              ))}
            </ul>
          )}
        </div>
      </PopoverContent>
    </Popover>
  );
}
